type PublicTheme = {
  colors?: {
    text?: string;
    cardBackground?: string;
    cardBorder?: string;
  };
};

export const publicText = ({ theme }: { theme?: PublicTheme }) => theme?.colors?.text ?? '#344767';

export const publicCard = ({ theme }: { theme?: PublicTheme }) =>
  theme?.colors?.cardBackground ?? 'rgba(255, 255, 255, 0.72)';

export const publicLine = ({ theme }: { theme?: PublicTheme }) =>
  theme?.colors?.cardBorder ?? 'rgba(0, 0, 0, 0.08)';

export const publicAccent = '#667eea';
